import React, { useMemo } from "react";

// Discrete rising bubbles effect. `count` bubbles randomized.
export default function Bubbles({ count = 14, className = "" }) {
  const bubbles = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const size = 4 + Math.random() * 22;
        return {
          id: i,
          left: Math.random() * 100,
          size,
          duration: 9 + Math.random() * 14,
          delay: Math.random() * 12,
        };
      }),
    [count]
  );

  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {bubbles.map((b) => (
        <span
          key={b.id}
          className="bubble"
          style={{
            left: `${b.left}%`,
            width: `${b.size}px`,
            height: `${b.size}px`,
            animationDuration: `${b.duration}s`,
            animationDelay: `${b.delay}s`,
          }}
        />
      ))}
    </div>
  );
}
